var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import DrawerHeader from 'syf-component-library/ui/atoms/DrawerHeader';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { useContext } from 'react';
import { useAccountSummaryV2Query } from 'syf-api';
import { useTranslation } from 'react-i18next';
import { accountIdType } from '../../../../const/config';
import { StyledBorder } from '../../../../styles/common';
import CBRContext from '../../context';
var CardHeader = function () {
    var _a;
    var t = useTranslation().t;
    var _b = useContext(CBRContext), accountId = _b.accountId, config = _b.config;
    var data = useAccountSummaryV2Query({
        config: config,
        keyProps: { accountId: accountId, accountIdType: accountIdType }
    }).data;
    if (!data) {
        return null;
    }
    var product = data.product, accountInfo = data.accountInfo, card = data.card;
    return (_jsxs(_Fragment, { children: [_jsx(Inset, __assign({ vertical: "base" }, { children: _jsx(DrawerHeader, { title: product.displayName || t('sandbox.defaultAccountLabel'), subtitle: "".concat(t('mocks.accountEnding', {
                        accountLast4: accountInfo.accountLast4
                    })), img: (_a = card.cardArtURL) !== null && _a !== void 0 ? _a : '', fallbackImage: "", alt: "" }) })), _jsx(StyledBorder, {})] }));
};
export default CardHeader;
